import { useMemo } from 'react'

export const useAdminSlidesSlice = <
  TSlides,
  TSlideForm,
  TSetSlideForm,
  TEditingId,
  TUpsertSlide,
  TResetSlideForm,
  TDeleteSlide,
  TSelectForEdit,
  TOnDropSlide,
  TOnDragStart,
>({
  slides,
  loading,
  slideForm,
  setSlideForm,
  editingId,
  upsertSlide,
  resetSlideForm,
  deleteSlide,
  selectForEdit,
  onDropSlide,
  onDragStart,
}: {
  slides: TSlides
  loading: boolean
  slideForm: TSlideForm
  setSlideForm: TSetSlideForm
  editingId: TEditingId
  upsertSlide: TUpsertSlide
  resetSlideForm: TResetSlideForm
  deleteSlide: TDeleteSlide
  selectForEdit: TSelectForEdit
  onDropSlide: TOnDropSlide
  onDragStart: TOnDragStart
}) =>
  useMemo(
    () => ({
      slides,
      loading,
      slideForm,
      setSlideForm,
      editingId,
      upsertSlide,
      resetSlideForm,
      deleteSlide,
      selectForEdit,
      onDropSlide,
      onDragStart,
    }),
    [
      deleteSlide,
      editingId,
      loading,
      onDragStart,
      onDropSlide,
      resetSlideForm,
      selectForEdit,
      setSlideForm,
      slideForm,
      slides,
      upsertSlide,
    ],
  )
